export function experienceDetailsAction(props) {
    return (dispatch) => {
        dispatch({ ...props });
    };
}